module.exports = __webpack_public_path__ + "static/media/Transmitter4.e380ebe5.jpg";